import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";
import ProductListFiltersAccordionSection, {
    ProductListFilterAccordionSectionStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import React, { FC, useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import addProductFilters from "@galarson/Overrides/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@galarson/Overrides/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import CustomApplicationState from "@galarson/Store/CustomApplicationState";
import { ManagedAccordionSection } from "@insite/mobius/AccordionSection";

const enum fields {
    expandByDefault = "expandByDefault",
    expandByDefaultTop = "expandByDefaultTop",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
        [fields.expandByDefaultTop]: boolean;
    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const properties = JSON.parse(JSON.stringify(state.pages.productList.productFilters));
    
    let wareHouseData = [];
    if(state.customData?.WareHuouseData?.dataViews){
        wareHouseData = JSON.parse(JSON.stringify(state.customData?.WareHuouseData?.dataViews?.warehouseData?.availableWarehouseFacets));
        wareHouseData = JSON.parse(wareHouseData);
    } 
    interface AttributeValueFacet {
        attributeValueId: string;
        value: string;
        valueDisplay: string;
        count: number;
        sortOrder: number;
        selected: boolean;
    }
    
    interface AttributeTypeFacet {
        attributeTypeId: string;
        name: string;
        nameDisplay: string;
        sortOrder: number;
        attributeValueFacets: AttributeValueFacet[];
    }
    
    const attributeTypeFacetsData: any[]= getProductListDataViewProperty(state, "attributeTypeFacets")??[];
    const newAttributeTypeFacetsData:AttributeTypeFacet[] = [
        ...attributeTypeFacetsData.filter(item => item.sortOrder !== 0), // Keep items that are not sortOrder 0
        ...attributeTypeFacetsData.filter(item => item.sortOrder === 0)  // Append items with sortOrder 0 at the end
    ];

    return{
    attributeTypeFacets: newAttributeTypeFacetsData,
    availableWarehouseFacets: wareHouseData,
    properties: properties?.properties
}};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const productListAttributeFiltersStyles: ProductListFilterAccordionSectionStyles = {};

const ProductListAttributeFilters: FC<Props> = ({
    attributeTypeFacets,
    addProductFilters,
    removeProductFilters,
    fields,
    availableWarehouseFacets,
    properties
}) => {
    // TODO ISC-11787 - make showMoreLimit configurable
    const showMoreLimit = 10;

    const onChangeFacet = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ attributeValueIds: [facet.id] });
        } else {
            addProductFilters({ attributeValueIds: [facet.id] });
        }
    };

    const toggleHouseId = (properties: any, wareHouseId: any)=> {
        let wareHouseIds = properties?.warehouseIds ? properties?.warehouseIds.split(',') : [];
    
        const index = wareHouseIds.indexOf(wareHouseId);
        if (index > -1) {
            wareHouseIds.splice(index, 1);
        } else {
            wareHouseIds.push(wareHouseId);
        }
        return wareHouseIds.join(',');
    }

    const onChangeFacetWareHouse = (facet: FacetModel) => {
         const newWareHouseIds =  toggleHouseId(properties, facet.id)
        addProductFilters({properties: {"warehouseIds": newWareHouseIds}});
    };

    return (
        <>
        {availableWarehouseFacets.length > 0 && <ProductListFiltersAccordionSection
            key="keyAvailableWarehouseFacets"
            title="Available Warehouses"
            facets={availableWarehouseFacets?.map((av:any) => {
                    return{
                        id: av.id,
                        name: av.name,
                        count:-1,
                        selected: av.selected
                    }
                }
            )}
            onChangeFacet={onChangeFacetWareHouse}
            showMoreLimit={showMoreLimit}
            expandByDefault={fields.expandByDefault}
            extendedStyles={productListCategoryFiltersStyles}
        />
        }
            
            <ManagedAccordionSection
            title={"Filter by"}
            initialExpanded={fields.expandByDefaultTop}
        >
            {attributeTypeFacets?.map(a =>
                a.attributeValueFacets ? (
                    <ProductListFiltersAccordionSection
                        key={a.attributeTypeId}
                        title={a.nameDisplay}
                        facets={a.attributeValueFacets.map<FacetModel>(av => ({
                            ...av,
                            id: av.attributeValueId,
                            name: av.valueDisplay,
                        }))}
                        onChangeFacet={onChangeFacet}
                        showMoreLimit={showMoreLimit}
                        expandByDefault={fields.expandByDefault}
                        extendedStyles={productListCategoryFiltersStyles}
                    />
                ) : null,
            )}
            </ManagedAccordionSection>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListAttributeFilters),
    definition: {
        group: "Product List",
        displayName: "Attribute Filters",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.expandByDefaultTop,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
